import React, { useEffect, useState } from "react";
import {
    getCustomers,
    addCustomer,
    updateCustomer,

    deleteCustomer
} from "../lib/firestoreService";

export default function Customers() {
    const [customers, setCustomers] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        company: "",
        address: ""
    });

    // ===== LOAD =====
    const loadCustomers = async () => {
        const data = await getCustomers();
        setCustomers(data);
    };

    useEffect(() => {
        loadCustomers();
    }, []);

    // ===== ADD CUSTOMER =====
    const add = async (e) => {
        e.preventDefault();

        const name = form.name.trim();
        if (!name) return;

        const payload = {
            name,
            email: form.email.trim(),
            phone: form.phone.trim(),
            company: form.company.trim(),
            address: form.address.trim()
        };

        if (editingId) {
            await updateCustomer(editingId, payload);
        } else {
            await addCustomer(payload);
        }

        setForm({
            name: "",
            email: "",
            phone: "",
            company: "",
            address: ""
        });

        setEditingId(null);
        loadCustomers();
    };

    // ===== DELETE CUSTOMER =====
    const remove = async (id) => {
        if (!window.confirm("Delete customer?")) return;
        await deleteCustomer(id);
        loadCustomers();
    };

    const edit = (customer) => {
        setEditingId(customer.id);

        setForm({
            name: customer.name || "",
            email: customer.email || "",
            phone: customer.phone || "",
            company: customer.company || "",
            address: customer.address || ""
        });
    };

    return (
        <div>
            <h2>Customer</h2>

            <form
                onSubmit={add}
                style={{ display: "grid", gap: 10, maxWidth: 520 }}
            >
                <input
                    placeholder="Nama"
                    value={form.name}
                    onChange={(e) =>
                        setForm({ ...form, name: e.target.value })
                    }
                />

                <input
                    placeholder="Company (optional)"
                    value={form.company}
                    onChange={(e) =>
                        setForm({ ...form, company: e.target.value })
                    }
                />

                <input
                    placeholder="Email (optional)"
                    value={form.email}
                    onChange={(e) =>
                        setForm({ ...form, email: e.target.value })
                    }
                />

                <input
                    placeholder="Phone (optional)"
                    value={form.phone}
                    onChange={(e) =>
                        setForm({ ...form, phone: e.target.value })
                    }
                />

                <textarea
                    placeholder="Alamat (optional)"
                    value={form.address}
                    rows={3}
                    onChange={(e) =>
                        setForm({ ...form, address: e.target.value })
                    }
                    style={{
                        resize: "vertical",
                        padding: 10,
                        fontFamily: "inherit"
                    }}
                />

                <button className="admin-btn" type="submit">
                    {editingId ? "Update Customer" : "Save Customer"}
                </button>
                {editingId && (
                    <button
                        type="button"
                        className="admin-btn ghost"
                        onClick={() => {
                            setEditingId(null);
                            setForm({
                                name: "",
                                email: "",
                                phone: "",
                                company: "",
                                address: ""
                            });
                        }}
                    >
                        Cancel Edit
                    </button>
                )}
            </form>

            <div style={{ marginTop: 20 }}>
                {customers.length === 0 ? (
                    <div className="admin-muted">Belum ada customer.</div>
                ) : (
                    <div className="admin-table">
                        {customers.map((c) => (
                            <div key={c.id} className="row">
                                <div>
                                    <div className="name">{c.company}</div>

                                    <div className="meta">
                                        {[c.name, c.email, c.phone]
                                            .filter(Boolean)
                                            .join(" • ")}
                                    </div>

                                    {c.address && (
                                        <div
                                            className="meta"
                                            style={{
                                                marginTop: 6,
                                                whiteSpace: "pre-line"
                                            }}
                                        >
                                            {c.address}
                                        </div>
                                    )}
                                </div>

                                <div style={{ display: "flex", gap: 8 }}>
                                    <button
                                        className="admin-btn ghost"
                                        onClick={() => edit(c)}
                                    >
                                        Edit
                                    </button>

                                    <button
                                        className="admin-btn danger ghost"
                                        onClick={() => remove(c.id)}
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}